import { registerPetroHouseServiceWorker } from './pwa-register.js';
import { upgradeAppBootOverlays } from './app-boot-message.js';
import { startAppBootProgress, syncAppBootProgressDom } from './app-boot-progress.js';

/** Mesmo boot visual do viewer/painel (engrenagens + %), sem barra de copyright no meio. */
export const INDEX_BOOT_STEPS = [
  { id: 'warmup', weight: 40, label: 'SysFactory · preparando seu workspace…' },
  { id: 'session', weight: 35, label: 'SysFactory · validando sua sessão' },
  { id: 'route', weight: 25, label: 'SysFactory · abrindo workspace' },
];

void registerPetroHouseServiceWorker();

upgradeAppBootOverlays(document);
startAppBootProgress(INDEX_BOOT_STEPS);
syncAppBootProgressDom();

await import('./entry-redirect.js');
